// extracted by mini-css-extract-plugin
export default {"tableTitle":"styles_tableTitle__k0DJD"};